"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MerchandiseSliderItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _productName = require("../productContent/productName");
var _productPrice = require("../productContent/productPrice");
var _productImage = require("../productContent/productImage");
var _productAvailability = require("../productContent/productAvailability");
var _wbmInputs = require("wbm-inputs");
var _AddShoppingCart = _interopRequireDefault(require("@material-ui/icons/AddShoppingCart"));
var _DropdownListView = require("../productObjects/DropdownListView");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var imageProps = {
  width: 180,
  height: 180
};
var MerchandiseSliderItem = exports.MerchandiseSliderItem = function MerchandiseSliderItem(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: props.displayBackground ? "merchandise-slider-item" : "merchandise-slider-item-no-background"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "badge badge-pill badge-danger"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-image mx-auto"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: props.productDetailsUrl
  }, /*#__PURE__*/_react["default"].createElement(_productImage.ProductImage, {
    imgUrl: props.productInfo.imageUrl,
    className: "image-container",
    altText: props.productInfo.itemId,
    width: imageProps.width,
    height: imageProps.height
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters merch-item-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-auto merch-item-product-name"
  }, /*#__PURE__*/_react["default"].createElement(_productName.ProductName, {
    brandName: props.productInfo.brandName,
    description: props.productInfo.description,
    itemIdentifier: props.productInfo.itemIdentifier,
    productHREF: props.productDetailsUrl,
    displayId: props.productInfo.itemId,
    textBold: false
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters merch-item-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react["default"].createElement(_productPrice.ProductPrice, {
    unitId: props.productInfo.unitId,
    unitPrice: props.productInfo.unitPrice
  }))), props.displayAddToCart && /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters merch-item-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement(_DropdownListView.DropdownListView, {
    list: props.listItems,
    itemSelected: props.dropdownSelectedItem
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "btn-outline-primary"
  }, /*#__PURE__*/_react["default"].createElement(_AddShoppingCart["default"], null), " ADD"))), props.availabilityInfo && /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters availability-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement(_productAvailability.ProductAvailability, {
    availabilityInfo: props.availabilityInfo,
    itemIdentifier: props.productInfo.itemIdentifier,
    smallText: false
  }))), props.displayShopButton && /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters merch-item-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: props.productDetailsUrl
  }, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: "wbm-button btn btn-outline-primary col-12"
  }, "SHOP")))))));
};
var _default = exports["default"] = MerchandiseSliderItem;
//# sourceMappingURL=merchandiseSliderItem.js.map